module.exports = __webpack_public_path__ + "img/frame_2.0212e2f.webp";